
























































































































import { Vue, Component, Emit } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import { DateTime } from 'luxon'
import moment from 'moment'
import ReservaSalaStore from '@/components/ReservaSala/Store/ReservaSalaStore'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import SolicitacaoCancelamentoStore from '@/components/SolicitacaoCancelamento/Store/SolicitacaoCancelamentoStore'
import { onlyNumber, humanTime, minutesToHours, getWeekdayByDate } from '@/utils/common'

import { CancelarSolicitacaoParam, TipoOrigemEnum } from '@/types/_'
import { ITriagem, Triagem } from '@/types/implements/Triagem'
import EventBus from '@/plugins/EventBus'

@Component

export default class ComponentBackofficeConfirmarTriagem extends Vue {
  $refs!: {
    confirmarTriagemRule: any,
    dateA: any,
  }

  loader: boolean = false
  loaderNumeroReserva: boolean = false
  numeroReservaMessage: string = ''
  dateText1: string = ''
  triagem: ITriagem = new Triagem()

  confirmarTriagemRule: any = {
    valid: false,
    dataCirurgia: [
      v => !!v || 'O campo data da cirurgia é obrigatório.',
    ],
    tempoCirurgia: [
      v => !!v || 'O campo tempo da cirurgia é obrigatório.',
    ],
    dataVirtual: [
      v => (v !== undefined && v !== null) || 'O campo data virtual é obrigatório.',
    ],
  }

  get getDateText1() {
    this.dateText1 = this.formatISOToDate(this.getBackofficeGlobalStore.solicitacao.dataAgendamento)
    return this.dateText1
  }

  set getDateText1(value: string | Date) {
    this.dateText1 = this.formatISOToDate(this.getBackofficeGlobalStore.solicitacao.dataAgendamento)
  }

  get getSolicitacaoCancelamentoStore() {
    return getModule(SolicitacaoCancelamentoStore, this.$store)
  }

  async showModalCancelamento() {
    const cancelarSolicitacaoParam: CancelarSolicitacaoParam = {
      solicitacaoId: this.getBackofficeGlobalStore.solicitacao.id,
      tipoOrigem: TipoOrigemEnum.Agendamento,
      situacao: this.getBackofficeGlobalStore.solicitacao.situacao,
      canceladoMotivo: {
        display: '',
        key: '',
      },
      modal: '',
    }

    if (this.getBackofficeGlobalStore.solicitacao.canceladoMotivo) {
      cancelarSolicitacaoParam.canceladoMotivo = this.getBackofficeGlobalStore.solicitacao.canceladoMotivo
    }

    this.getSolicitacaoCancelamentoStore.setCancelarSolicitacaoParam(cancelarSolicitacaoParam)
    this.getSolicitacaoCancelamentoStore.setShowModalCancelamentoTriagem(true)
    await this.getSolicitacaoCancelamentoStore.getMotivosCancelamentoAll({ hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId })
  }

  clearDate(event) {
    this.getBackofficeGlobalStore.solicitacao.dataAgendamento = ''
    this.$refs.dateA.close(event)
  }

  clickDateTime(event) {
    if (!this.getBackofficeGlobalStore.solicitacao.dataAgendamento) {
      this.getBackofficeGlobalStore.solicitacao.dataAgendamento = moment(new Date()).format('YYYY-MM-DDT12:00')
    }

    this.$refs.dateA.open(event)
  }

  formatISOToDate(value: string | Date) {
    if (value === '') return value
    return DateTime.fromISO(value).toLocaleString(DateTime.DATETIME_MED)
  }

  eventRender(info) {
    if (info.event.extendedProps.dataAgendamentoVirtual) {
      const span = document.createElement('span')
      span.setAttribute('class', 'fa fa-building white--text ml-2')
      info.el.appendChild(span)
    }
  }

  get getReservaSalaStore() {
    return getModule(ReservaSalaStore, this.$store)
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getReservaSalasResources() {
    return this.getReservaSalaStore.reservaSalasResource || []
  }

  get getReservaSalasEvents() {
    return this.getReservaSalaStore.reservaSalasEvent
  }

  get loading() {
    return this.loader
  }

  set loading(value: boolean) {
    this.loader = value
  }

  get loadingNumeroReserva() {
    return this.loaderNumeroReserva
  }

  set loadingNumeroReserva(value: boolean) {
    this.loaderNumeroReserva = value
  }

  get doctorDeadlineJustification() {
    const { justificativaDePrazo: doctorDeadlineJustification } = this.getBackofficeGlobalStore.solicitacao

    return doctorDeadlineJustification
  }

  get surgeryWeekday() {
    return this.getDateText1 ? getWeekdayByDate(this.getDateText1) : ''
  }

  get surgerySuggestedDate() {
    const { healthInsuranceData } = this.getBackofficeGlobalStore
    const sundayIndexWeekDay = 0
    let surgerySuggestedDateObject
    let surgerySuggestedDate

    const {
      prazoEmDiasParaSolicitarCirurgiaComOpme: suggestedSurgeryDateDaysWithOPME,
      prazoEmDiasParaSolicitarCirurgiaSemOpme: suggestedSurgeryDateDaysWithoutOPME,
    } = healthInsuranceData

    if (suggestedSurgeryDateDaysWithOPME && suggestedSurgeryDateDaysWithoutOPME) {
      if (this.surgeryHasOPME) {
        surgerySuggestedDateObject = moment().add(suggestedSurgeryDateDaysWithOPME, 'days')
      } else {
        surgerySuggestedDateObject = moment().add(suggestedSurgeryDateDaysWithoutOPME, 'days')
      }

      surgerySuggestedDate = surgerySuggestedDateObject

      if (surgerySuggestedDateObject.day() === sundayIndexWeekDay) {
        surgerySuggestedDate = surgerySuggestedDate.add(1, 'days')
      }


      return surgerySuggestedDate.format('DD/MM/YYYY')
    }

    return null
  }

  get surgeryHasOPME() {
    return this.getBackofficeGlobalStore.solicitacao.temOpme
  }

  getDatasPrevistas() {
    const datas = [
      this.getBackofficeGlobalStore.solicitacao.opcaoDataPrevisto1,
      this.getBackofficeGlobalStore.solicitacao.opcaoDataPrevisto2,
      this.getBackofficeGlobalStore.solicitacao.opcaoDataPrevisto3,
    ]
    return datas.filter(e => !['', null, undefined].includes(e)).map(e => humanTime(e || '')).join(', ')
  }

  onlyNumberUtil(value) {
    return onlyNumber(value)
  }

  minutesToHoursUtil(value) {
    return minutesToHours(value)
  }

  async checkNumeroReserva() {
    const numeroReserva: string = this.getBackofficeGlobalStore.solicitacao.numeroAgendamento
    this.loadingNumeroReserva = true
    if (numeroReserva) {
      const params: any = {
        solicitacaoId: this.getBackofficeGlobalStore.solicitacao.id,
        numeroReserva,
        hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId,
      }

      const response = await this.triagem.getCheckNumeroReserva(params)
      this.loadingNumeroReserva = false

      if (!response.success) {
        this.numeroReservaMessage = ''
        EventBus.$emit('setSnackbar', { show: true, text: 'Houve um erro na validação no número de reserva.', icon: 'warning', color: '#C62828' })
        return false
      }

      if (response.success && response.data) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Número de reserva duplicado.', icon: 'warning', color: '#C62828' })
        this.numeroReservaMessage = 'Número de reserva duplicado.'
        return false
      }

      this.numeroReservaMessage = ''
      return true
    }

    this.numeroReservaMessage = 'O campo número de reserva é obrigatório.'
    this.loadingNumeroReserva = false
    return false
  }

  modalReset() {
    this.$refs.confirmarTriagemRule.reset()
    this.loading = false
  }

  windowWidth: number = 0
  getWindowWidth() {
    this.windowWidth = document.documentElement.clientWidth
  }

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  }

  updated() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  }

  @Emit('setStep')
  backStep(step) { }

  @Emit('confirmarTriagem')
  confirmarTriagem() { }
}
